import { createIcon } from '@chakra-ui/react';

export const HamburgerMenuIcon = createIcon({
  displayName: 'HamburgerMenuIcon',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_2883_66997)">
          <path d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z" fill="#3F3F46" />
        </g>
        <defs>
          <clipPath id="clip0_2883_66997">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  ),
});
